import { populate } from "populate";

const raw = {
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: "b833f8da-666c-43dc-a230-32186fb93d01",
      type: "Container",
      name: "root",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "",
      data: ""
    },
    {
      id: "55cbaed3-cdf5-4e40-bae6-15679ea823ba",
      type: "NineSlicePlane",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 358,
        y: 297
      },
      width: 716,
      height: 594,
      leftWidth: 297,
      topHeight: 224,
      rightWidth: 289,
      bottomHeight: 238,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "popup_background_2",
      parent: "b833f8da-666c-43dc-a230-32186fb93d01",
      data: ""
    },
    {
      id: "b43af4d3-175a-48d3-8211-894279a5d3ff",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: -287,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "popup_title_purchase",
      parent: "b833f8da-666c-43dc-a230-32186fb93d01",
      data: ""
    },
    {
      id: "078e3dfb-8a5c-404c-bd1a-f8518cb90018",
      type: "Text",
      name: "headerText",
      nameSpace: "",
      className: "",
      x: 0,
      y: -295,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "StreakInfoHeader",
      localize: true,
      maxWidth: 471,
      maxHeight: 60,
      maxFontSize: 49,
      icons: [],
      style: {
        fontSize: 29,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#ffffff",
        stroke: "#933019",
        strokeThickness: 6,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.8,
        dropShadowBlur: 0,
        dropShadowColor: "#b83500",
        dropShadowDistance: 3,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "b833f8da-666c-43dc-a230-32186fb93d01",
      data: ""
    },
    {
      id: "92c42b90-2192-495e-a3cd-d89d0ac53cc5",
      type: "Sprite",
      name: "playContainer",
      nameSpace: "",
      className: "",
      x: 0,
      y: 265,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blank",
      parent: "b833f8da-666c-43dc-a230-32186fb93d01",
      data: ""
    },
    {
      id: "ba4fb4a2-28b8-4389-b4cf-b36184efdf98",
      type: "Sprite",
      name: "closeButton",
      nameSpace: "",
      className: "",
      x: 331,
      y: -275,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: "None"
      },
      texture: "btn_close",
      parent: "b833f8da-666c-43dc-a230-32186fb93d01",
      data: ""
    },
    {
      id: "be3c8aaa-8da3-4386-a0c2-63a074c3bf62",
      type: "Text",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 95,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "StreakInfo",
      localize: true,
      maxWidth: 673,
      maxHeight: 147,
      maxFontSize: 31,
      icons: [],
      style: {
        fontSize: 23,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#933019",
        stroke: "black",
        strokeThickness: 0,
        align: "center",
        wordWrap: true,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "b833f8da-666c-43dc-a230-32186fb93d01",
      data: ""
    },
    {
      id: "b492955e-83da-44e5-afd9-bcd8681b847d",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: -96,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "combo_info",
      parent: "b833f8da-666c-43dc-a230-32186fb93d01",
      data: ""
    },
    {
      id: "ebbcb5b4-ebe1-4ffa-adf4-871f2773135e",
      type: "Sprite",
      name: "playButton",
      nameSpace: "",
      className: "",
      x: 0,
      y: 5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: "None"
      },
      texture: "button_medium_green",
      parent: "92c42b90-2192-495e-a3cd-d89d0ac53cc5",
      data: ""
    },
    {
      id: "3752a096-64bf-4a42-b0e2-7573ea890f0a",
      type: "Text",
      name: "playText",
      nameSpace: "",
      className: "",
      x: 0,
      y: -6,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "Continue",
      localize: true,
      maxWidth: 226,
      maxHeight: 71,
      maxFontSize: 48,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#ffffff",
        stroke: "#17762e",
        strokeThickness: 6,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "ebbcb5b4-ebe1-4ffa-adf4-871f2773135e",
      data: ""
    }
  ]
} as const;

export class StreakInfoPopupLayout {
  static raw = raw;
  root: GameObject<PIXI.Container>;
  headerText: GameObject<PIXI.Text>;
  playContainer: GameObject<PIXI.Sprite>;
  playButton: GameObject<PIXI.Sprite>;
  playText: GameObject<PIXI.Text>;
  closeButton: GameObject<PIXI.Sprite>;

  constructor() {
    populate(this, raw);
  }
}
